var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "form", attrs: { novalidate: "" } },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 col-lg-6" },
              [
                _c("section-title", {
                  attrs: {
                    "container-class": "tag-badge-main-info mt-4 mb-4",
                    content:
                      "VII. Pareo Ocupacional con la Meta Vocacional, Intereses",
                    icon: "fas fa-clipboard-list-check"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-6 d-flex justify-content-lg-end align-items-center"
              },
              [
                _c("action-button", {
                  attrs: {
                    i: _vm.allExpanded
                      ? "fal fa-compress-alt"
                      : "fal fa-expand-alt",
                    text: _vm.allExpanded ? "Colapsar Todo" : "Expandir Todo",
                    variant: "outline-secondary expand-all-btn"
                  },
                  on: {
                    click: function($event) {
                      return _vm.toggleExpandAll(!_vm.allExpanded)
                    }
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "mx-3" },
            [
              _c(
                "custom-collapse",
                { attrs: { id: "riasec-and-interest-collapse" } },
                _vm._l(_vm.riasecAndInterestCategories, function(item) {
                  return _c(
                    "custom-collapse-item",
                    {
                      key: `section-${item.id}`,
                      ref: "riasecCollapseItems",
                      refInFor: true,
                      staticClass: "my-3 collapse-item section bg-gray",
                      attrs: {
                        auto: "",
                        "expanded-icon":
                          "fas fa-chevron-circle-right color-gray-7",
                        "minimized-icon":
                          "fas fa-chevron-circle-down color-warning",
                        "parent-id": "riasec-and-interest-collapse",
                        "read-only-icon": "fas fa-plus-circle color-gray-2",
                        "start-expanded": "",
                        title: item.name
                      },
                      on: { expandButtonClick: _vm.syncExpandButtonState }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "bg-white p-3 rounded" },
                        _vm._l(item.areas, function(area) {
                          return _c(
                            "div",
                            { key: `section-area-${area.area.id}` },
                            [
                              _c("answer", {
                                attrs: {
                                  "is-read-only": _vm.isReadOnly,
                                  value: area
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.onAnswer(item, $event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c("section-title", {
            attrs: {
              content:
                "Factores ocupacionales relacionados al interés del evaluado"
            }
          }),
          _c(
            "div",
            { staticClass: "mx-3" },
            [
              _c(
                "custom-collapse",
                { attrs: { id: "factors-collapse" } },
                [
                  _c("ged-occupational-factors", {
                    ref: "gedCollapse",
                    attrs: { "is-read-only": _vm.isReadOnly },
                    on: { expandButtonClick: _vm.syncExpandButtonState },
                    model: {
                      value: _vm.model.gedConfigurationDto,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "gedConfigurationDto", $$v)
                      },
                      expression: "model.gedConfigurationDto"
                    }
                  }),
                  _c("svp-occupational-factors", {
                    ref: "svpCollapse",
                    attrs: { "is-read-only": _vm.isReadOnly },
                    on: { expandButtonClick: _vm.syncExpandButtonState },
                    model: {
                      value: _vm.model.svpConfigurationDto,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "svpConfigurationDto", $$v)
                      },
                      expression: "model.svpConfigurationDto"
                    }
                  }),
                  _c("aptitude-occupational-factors", {
                    ref: "aptitudeCollapse",
                    attrs: { "is-read-only": _vm.isReadOnly },
                    on: { expandButtonClick: _vm.syncExpandButtonState },
                    model: {
                      value: _vm.model.aptitudeConfigurationDto,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "aptitudeConfigurationDto", $$v)
                      },
                      expression: "model.aptitudeConfigurationDto"
                    }
                  }),
                  _c("goe-occupational-factors", {
                    ref: "goeCollapse",
                    attrs: { "is-read-only": _vm.isReadOnly },
                    on: { expandButtonClick: _vm.syncExpandButtonState },
                    model: {
                      value: _vm.model.goeConfigurationDto,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "goeConfigurationDto", $$v)
                      },
                      expression: "model.goeConfigurationDto"
                    }
                  }),
                  _vm._l(_vm.evaluatedCategories, function(item) {
                    return _c(
                      "custom-collapse-item",
                      {
                        key: `factors-section-${item.id}`,
                        ref: "evaluatedCollapseItems",
                        refInFor: true,
                        staticClass: "my-3 collapse-item section bg-gray",
                        attrs: {
                          auto: "",
                          "expanded-icon":
                            "fas fa-chevron-circle-right color-gray-7",
                          "minimized-icon":
                            "fas fa-chevron-circle-down color-warning",
                          "parent-id": "factors-collapse",
                          "read-only-icon": "fas fa-plus-circle color-gray-2",
                          "start-expanded": "",
                          title: item.name
                        },
                        on: { expandButtonClick: _vm.syncExpandButtonState }
                      },
                      [
                        item.leyends?.length
                          ? _c(
                              "div",
                              { staticClass: "legend-bar mb-3" },
                              _vm._l(item.leyends, function(legend) {
                                return _c(
                                  "span",
                                  {
                                    key: legend.id,
                                    staticClass: "legend-bar__item"
                                  },
                                  [_vm._v(" " + _vm._s(legend.name) + " ")]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "bg-white p-3 rounded" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            _vm._l(item.areas, function(area) {
                              return _c(
                                "div",
                                {
                                  key: `section-area-${area.area.id}`,
                                  class: [
                                    _vm.isHalf(item)
                                      ? "col-md-6 col-12"
                                      : "col-12"
                                  ]
                                },
                                [
                                  _c("evaluated-area-answer", {
                                    attrs: {
                                      "answer-options": item.questions,
                                      "is-half": _vm.isHalf(item),
                                      "is-read-only": _vm.isReadOnly,
                                      "state-options": item.states,
                                      value: area,
                                      "yes-no-options": item.options
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onAnswer(item, $event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm.hasCategoryComment(item)
                            ? _c(
                                "div",
                                [
                                  _c("label", [_vm._v("Observaciones:")]),
                                  _c("custom-text-area", {
                                    attrs: {
                                      "count-classes": [
                                        "d-block",
                                        "small-counter",
                                        "text-right"
                                      ],
                                      disabled: _vm.isReadOnly,
                                      maxlength: 5000,
                                      placeholder: "Comentario",
                                      "show-char-count": "",
                                      value: _vm.categoryComment(item)
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.setCategoryComment(
                                          item,
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }